/**
 * @ngdoc function
 * @name lmApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the lmApp
 */

lmApp
  .controller('WelcomeController', ['$scope', '$rootScope', '$location', '$timeout', 'AuthenticationService', 'ApiService',
    function ($scope, $rootScope, $location, $timeout, AuthenticationService, ApiService) {
      //reset login status
      AuthenticationService.ClearCredentials();

      $scope.loginFormData = {
        location: window.location.origin,
        inputs: {
          email: '',
          pswd: '',
        },

        validate: {
          email: function () {
            //TODO: Validate EMAIL
          },
          pswd: function () {
            //TODO: Validate PASSWORD
          }
        },

        loading: false,
        error: '',

        login: function () {
          if (this.loading) return;

          this.error = '';
          this.loading = true;

          $rootScope.showLinearProgress('#welcomeLoader');
          AuthenticationService.Login($scope.loginFormData.inputs.email, $scope.loginFormData.inputs.pswd)
            .then(function(response) {
              ApiService.SetToken(response.access_token);
              $rootScope._self = response.self.operator;
              return AuthenticationService.SetCredentials(
                      $scope.loginFormData.inputs.email,
                      response.self,
                      response.access_token
                  );
              })
            .then(function () {

              $timeout(function () {
                $scope.loginFormData.loading = false;
                $rootScope.hideLinearProgress('#welcomeLoader');

                $rootScope.$broadcast('self:update', $rootScope._self);
                if ($rootScope.globals.currentUser.isSuperuser) {
                      $location.path($rootScope.defaultAdminRoute);
                  } else {
                      $location.path($rootScope.defaultRoute);
                  }

              }, 1000);
            }, function (reason) {
              $scope.loginFormData.inputs.pswd = '';
              $scope.loginFormData.loading = false;
              if (reason.message && (reason.message === 'invalid credentials' || reason.message === 'invalid client' || reason.message === 'invalid signature')) {
                $scope.loginFormData.error = 'Username and/or Password Invalid';
              } else {
                $rootScope.debugInfo(reason, true);
              }
              $rootScope.hideLinearProgress('#welcomeLoader');
            });
        },

        register: function () {
          if (this.loading) return;

          $location.path('/register');
        }
      };
    }]);
